import { render, staticRenderFns } from "./PublicDetail.vue?vue&type=template&id=5bff3a08"
import script from "./PublicDetail.vue?vue&type=script&lang=ts"
export * from "./PublicDetail.vue?vue&type=script&lang=ts"
import style0 from "./PublicDetail.vue?vue&type=style&index=0&id=5bff3a08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports